export default {
	listOfDeals: [],
	status:      null,
	page:        1,
	pages:       0
};
